module.exports = __webpack_public_path__ + "img/image-accueil-2.a7bfaac9.jpg";